<template>
  <div class="back">
    <NavBar
      title="查询邀请"
      left-text="首页"
      left-arrow
      @click-left="onClickLeft"
      style="z-index: 9999"
    />
    <Popup
      :show="showAddCustomerService"
      teleport="#app"
      @click-overlay="showAddCustomerService = false"
      round
    >
      <WeChat title="长按二维码加客服提现" />
    </Popup>
    <Popup
      v-model:show="showInputPhone"
      :close-on-click-overlay="false"
      round
      position="bottom"
      :style="{ height: '26%' }"
      class="inputPhoneBox"
    >
      <template #default>
        <Search
          v-model="searchValue"
          shape="round"
          center
          background="#00000000"
          style="font-weight: bold"
          placeholder="此处请输入您的邀请人手机号"
        >
          <template #right-icon>
            <Button
              round
              size="small"
              type="success"
              class="inputPhoneSearch"
              @click="queryInvite"
              >查 询</Button
            >
          </template>
        </Search>
        <div class="inputPhoneTips">
          <span
            >下单手机号：<br />考试对应的易班手机号<br />或是你创建邀请链接的手机号</span
          >
          <br />
          <br />
          <span style="font-size: 13px; color: #c8e429"
            >💰若没有下过订单，可以直接输入手机号创建邀请链接💰</span
          >
          <br />
        </div>
      </template>
    </Popup>
    <div>
      <!-- 上半部分数据展示区 -->
      <div style="position: relative; margin-bottom: 16px">
        <img src="/inviteIndex.png" style="width: 100%" />
        <!-- 考试总数 -->
        <div style="width: 92px; left: 71px" class="inviteDefaultFont">
          <span>{{ inviteeInfo.Total }}</span>
        </div>
        <!-- 可提现余额 -->
        <div style="width: 112px; left: 198px" class="inviteDefaultFont">
          <span
            >{{ inviteeInfo.cashAvailable }}<span class="inviteRMB">¥</span>
          </span>
        </div>
        <!-- 立即提现按钮 -->
        <div class="withdrawalButton" @click="withdrawa">立即提现</div>
      </div>
      <div class="moduleBox" style="height: 396px">
        <img
          src="/inviteDetailTitle.png"
          style="width: 89%; margin-top: 13px"
        />
        <div class="inviteSummary">
          <span style="margin-left: 30px">邀请人: {{ inviteeInfo.phone }}</span>
          <span style="margin-right: 23px"
            >历史总金额: {{ inviteeInfo.cash }} ¥</span
          >
        </div>
        <div class="inviteList">
          <PullRefresh v-model="refreshing" @refresh="onRefresh">
            <empty
              image="/custom-empty-image.png"
              image-size="80"
              v-if="detailData.length < 1"
            >
              <template #description>
                <span>暂无您的邀请记录噢</span>
                <br />
                <span>快快复制下面链接去邀请吧!</span>
              </template>
            </empty>
            <List
              v-model:loading="loading"
              :finished="finished"
              finished-text="没有更多了..(仅显示最近3天详细数据)"
              success-text="刷新成功"
              :offset="0"
              @load="onLoad"
              v-if="detailData.length >= 1"
            >
              <CellGroup>
                <Cell
                  style="padding-bottom: 7px"
                  v-for="(item, index) in detailData"
                  v-bind:key="index"
                  :title="item.inviteePhone"
                  :label="item.orderTime"
                  title-style="font-size: 21px; font-weight: bold; color:#000000a8;"
                >
                  <template #value>
                    <div class="detailMoney">
                      {{ calcCashBack(item.totalSubject, item.cashBackAmount)
                      }}<span>¥</span>
                    </div>
                    <span style="font-size: 12px"
                      >= {{ item.totalSubject }} *
                      {{ item.cashBackAmount }}</span
                    >
                  </template>
                </Cell>
              </CellGroup>
            </List>
          </PullRefresh>
        </div>
        <Field
          v-model="inviteUrl"
          label-align="center"
          center
          clearable
          label="邀请链接"
          label-width="4em"
          style="background: #00000008; border-radius: 0 0 12px 12px"
        >
          <template #button>
            <Button size="small" type="danger" @click="copyInviteUrl"
              >复制</Button
            >
          </template>
        </Field>
      </div>
      <div class="moduleBox" style="padding-bottom: 10px">
        <img src="/description.png" style="width: 89%; margin-top: 13px" />
        <img src="/inviteMoney.png" style="width: 90%" />
        <br />
        <span style="font-size: 11px">
          每单返现金额 = 被邀请人考试题数 * 对应返现等级
        </span>
      </div>
      <div style="height: 1px"></div>
    </div>
  </div>
</template>
<script setup>
import {
  NavBar,
  Toast,
  Cell,
  CellGroup,
  Popup,
  Field,
  Button,
  Empty,
  Search,
  List,
  PullRefresh,
  Dialog,
} from "vant";
import { ref, computed } from "vue";
import WeChat from "@/components/WeChat.vue";
import { inviteService } from "@/service/inviteService";
import copy from "@/utils/copy";

const loading = ref(false);
const finished = ref(false);
const refreshing = ref(false);
const currentPage = ref(1);
const errOrder = ref(0);
const totalMoney = ref(0);
const detailData = ref([]);
const inviteeInfo = ref({
  Total: 0,
  cash: 0,
  cashAvailable: 0,
  phone: "",
  inviteCode: "",
});

const showInputPhone = ref(true);
const searchValue = ref("");
const showAddCustomerService = ref(false);
const withdrawa = () => (showAddCustomerService.value = true);
const onClickLeft = () => history.back();

// 计算inviteUrl值
const inviteUrl = computed(() => {
  return `http://${document.domain}/?inviteCode=${inviteeInfo.value.inviteCode}`;
});
// 复制邀请链接
const copyInviteUrl = () => {
  copy(inviteUrl.value);
  Toast("复制成功!");
};
// 点击查询事件
const queryInvite = () => {
  try {
    let inputSearch = searchValue.value;
    if (inputSearch == "") throw "请输入你时的邀请人手机号";
    let phoneReg = /^[1][3-9]\d{9}$/;
    if (phoneReg.test(inputSearch)) {
      // 查询是否有邀请记录
      refreshData(inputSearch, "1")
        .then((res) => {
          if (res["list"].length <= 0 && res["recordsTotal"] == 0) {
            Dialog.confirm({
              title: "告诉你一件事",
              message:
                "没有查询到你邀请过的记录\n或者\n是你没有创建过邀请链接！",
              theme: "round-button",
              confirmButtonText: "立马创建",
              cancelButtonText: "输错了",
            }).then(() => {
              showInputPhone.value = false;
              inviteeInfo.value = {
                Total: res["recordsTotal"],
                cash: res["cash"],
                cashAvailable: res["cashAvailable"],
                phone: inputSearch,
                inviteCode: res["inviteCode"],
              };
            });
          } else {
            showInputPhone.value = false;
            inviteeInfo.value = {
              Total: res["recordsTotal"],
              cash: res["cash"],
              cashAvailable: res["cashAvailable"],
              phone: inputSearch,
              inviteCode: res["inviteCode"],
            };
          }
        })
        .catch((err) => {
          throw err["result"];
        });
    } else {
      throw "你输入的是什么鬼东东 ???";
    }
  } catch (err) {
    Toast(err);
  }
};
// 下来刷新列表
const onRefresh = () => {
  finished.value = false;
  detailData.value = [];
  currentPage.value = 1;
  errOrder.value = 0;
  totalMoney.value = 0;
  // 下拉刷新第一页
  refreshData(searchValue.value, "1")
    .then(() => {
      refreshing.value = false;
    })
    .catch((err) => {
      console.log(err);
    });
};
// 拉倒最底部更新页数据
const onLoad = () => {
  currentPage.value++;
  // 滑到最底部更新下一页数据
  refreshData(searchValue.value, currentPage.value.toString())
    .then((res) => {
      loading.value = false;
      if (detailData.value.length >= res["recordsTotal"] - errOrder.value) {
        finished.value = true;
      }
    })
    .catch((err) => Toast(err));
};
// 获取邀请人数据
const refreshData = (inviteePhone, pageIndex) => {
  return new Promise((resolve, reject) => {
    inviteService
      .getInviteList(inviteePhone, pageIndex)
      .then((res) => {
        // 加入Redis错误数量
        errOrder.value += res["result"]["errOrder"];
        res["result"]["list"].forEach((element) => {
          // 加入至渲染列表
          detailData.value.push(element);
          // 计算总金额
          totalMoney.value =
            Math.round((totalMoney.value + element.cashBack) * 100) / 100;
        });
        inviteeInfo.value.cash = res["result"]["cash"];
        inviteeInfo.value.cashAvailable = res["result"]["cashAvailable"];
        inviteeInfo.value.Total = res["result"]["recordsTotal"];
        // 执行上层命令
        resolve(res["result"]);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 计算返现金额
const calcCashBack = (totalSubject, cashBack) => {
  let num = Math.floor(cashBack * parseFloat(totalSubject) * 100) / 100;
  let nums = (num || 0).toString().split(".");
  return nums[0] + "." + (nums[1] || "0").padEnd(2, "0");
};
</script>

<style>
.back {
  background: url(/back.png) no-repeat right top;
  background-size: cover;
}

.inputPhoneBox {
  background: rgb(255 255 255 / 13%);
  backdrop-filter: blur(31px);
}

.inputPhoneSearch {
  letter-spacing: 6px;
  text-indent: 6px;
  font-weight: bold;
}

.inputPhoneTips {
  text-align: center;
  color: #ddd;
  font-size: 14px;
  font-weight: bold;
}

@keyframes shakeButton {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

.inviteDefaultFont {
  color: #ff4549;
  letter-spacing: -3px;
  font-weight: 700;
  font-size: 46px;
  bottom: 91px;
  position: absolute;
  text-align: center;
}

.inviteRMB {
  color: #4b4b4b;
  font-size: 18px;
  text-indent: 1px;
  margin-left: 3px;
}

.withdrawalButton {
  position: absolute;
  bottom: 28px;
  left: 94px;
  width: 200px;
  height: 32px;
  background: #ff6c48;
  border-radius: 50px;
  box-shadow: 2px 3px 4px 1px #ddd;
  text-align: center;
  line-height: 32px;
  letter-spacing: 5px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
  animation-name: shakeButton;
  animation-duration: 0.8s;
  animation-iteration-count: infinite;
}

.detailMoney {
  font-size: 28px;
  font-weight: 600;
  color: #ff5551;
  height: 21px;
}

.detailMoney span {
  font-size: 12px;
  color: #0000008c;
  margin-left: 3px;
}

.moduleBox {
  width: 80%;
  margin: 0px auto 30px;
  background: rgb(255 255 255);
  border-radius: 12px;
  text-align: center;
}

.inviteSummary {
  font-size: 12px;
  color: #0d0d0d8f;
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
}

.inviteList {
  height: 67%;
  overflow: scroll;
  border-top: 0.4px solid #00000038;
  border-bottom: 0.4px solid #00000038;
  padding: 0px 7px;
}
</style>
